document.addEventListener("DOMContentLoaded", function () {
    const section = document.getElementById("shifts-section");
    if (!section) return;

    const shiftsText = section.querySelector(".shifts-text-block");
    if (!shiftsText) return;

    // Mark that motion styles can apply (activates the "hidden" state in CSS)
    document.body.classList.add("shifts-motion-ready");

    // Helper: actually trigger the fade/move-up once
    const show = () => {
        if (shiftsText.classList.contains("is-visible")) return;

        // Double rAF so the browser has time to apply the hidden state
        // before we add .is-visible → guarantees the transition runs
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                shiftsText.classList.add("is-visible");
            });
        });
    };

    // If IntersectionObserver isn't supported, just show with animation
    if (!("IntersectionObserver" in window)) {
        show();
        return;
    }

    const observerOptions = {
        root: null,
        threshold: 0.3,              // ~30% of section visible
        rootMargin: "0px 0px -10% 0px"
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                show();
                observer.disconnect();   // one-shot, no reverse
            }
        });
    }, observerOptions);

    observer.observe(section);

    // If it's already in view on load (e.g. large screens), trigger immediately
    const rect = section.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const alreadyInView = rect.top < vh * 0.8 && rect.bottom > vh * 0.2;

    if (alreadyInView) {
        show();
    }
});